import React, { useCallback, useMemo } from 'react';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';

import navbarReduce from '../../shared/data/navbar/navbarReduce';
import formatFieldsObjToSnake from 'Shared/util/formatFieldsObjToSnake';

import Page from 'Components/Page';
import TabQuotations from './components/TabQuotations';
import TabInProgress from './components/TabInProgress';
import TabCompleted from './components/TabCompleted';
import TabRequested from './components/TabRequested';
import ReactGA from 'Shared/analytics';

import withAuthentication from 'Components/withAuthentication';
import AppSwitch from 'Components/AppSwitch';

const Orders = ({ profileData, indicationTab }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabRouter = (
    <>
      <AppSwitch>
        <Route path="/customer/orders/" exact render={() => <Redirect to="/customer/orders/quotations/" />} />
        <Route path="/customer/orders/quotations/" component={TabQuotations} />
        <Route path="/customer/orders/in_progress/" component={TabInProgress} />
        <Route path="/customer/orders/completed/" component={TabCompleted} />
        <Route path="/customer/orders/requested/" component={TabRequested} />
      </AppSwitch>
    </>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3];
  }, [pathname]);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== activeTabId) {
        history.replace(`/customer/orders/${tabClicked}/`);
        ReactGA.pageview(`/customer/orders/${tabClicked}/`, 'Orders' + tabClicked);
      }
    },
    [history, activeTabId],
  );

  return (
    <Page
      props={{
        titleProps: {
          text: 'Orders',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'quotations',
                label: 'QUOTATIONS',
              },
              {
                id: 'in_progress',
                label: 'IN PROGRESS',
              },
              {
                id: 'completed',
                label: 'COMPLETED',
              },
              {
                id: 'requested',
                label: 'REQUESTED',
              },
            ],
            onTabClick: handleTabClick,
            activeTabId,
            indicationTabs: indicationTab && formatFieldsObjToSnake(indicationTab.orderMetaInfo),
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'orders',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(Orders);
